// CB:BEGIN contractor-bid-agreement-page
/**
 * CoreBids Contractor Platform Agreement — standalone page view.
 * Agreement content is fetched from GET /api/agreements/contractor-platform (canonical markdown).
 * No hardcoded text: all content lives in docs/agreements/contractor-platform-agreement.v2.md
 */
import React from 'react';
import SharedHeaderHomeowner from './SharedHeaderHomeowner';
import AgreementViewer from './AgreementViewer';
import { getApiUrl } from '../lib/getApiUrl';

interface ContractorBidAgreementProps {
  onNavigate: (screen: string) => void;
}

const ContractorBidAgreement: React.FC<ContractorBidAgreementProps> = ({ onNavigate }) => (
  <div className="container">
    <SharedHeaderHomeowner onNavigate={onNavigate} />
    <div className="content" style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '16px', fontSize: '36px', fontWeight: 700, color: '#1f2937' }}>
        CoreBids Contractor Agreements
      </h1>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap', marginBottom: '32px' }}>
        <a
          href={getApiUrl('/api/agreements/contractor-platform/pdf')}
          download="CoreBids-Contractor-Platform-Agreement-v3.pdf"
          className="btn btn-secondary"
          style={{ fontSize: 14, padding: '8px 20px', textDecoration: 'none', display: 'inline-block' }}
        >
          Download Platform Agreement (PDF)
        </a>
        <a
          href={getApiUrl('/api/agreements/contractor-bid/pdf')}
          download="CoreBids-Contractor-Bid-Agreement.pdf"
          className="btn btn-secondary"
          style={{ fontSize: 14, padding: '8px 20px', textDecoration: 'none', display: 'inline-block' }}
        >
          Download Bid Agreement (PDF)
        </a>
      </div>
      <div
        style={{
          background: '#ffffff',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          lineHeight: 1.6,
          color: '#374151',
        }}
      >
        <AgreementViewer agreementType="contractor-platform" maxHeight="none" />
      </div>
    </div>
  </div>
);

export default ContractorBidAgreement;
// CB:END contractor-bid-agreement-page
